var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhanHeReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#2A7DFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33083_160978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1024 26.1268H23.52V26.8874H13.1024V26.1268ZM13.1024 22.9327H23.52V23.6955H13.1024V22.9327ZM13.1024 19.7385H23.52V20.4992H13.1024V19.7385ZM13.1024 16.5444H23.52V17.305H13.1024V16.5444ZM17.9264 13.3503H23.52V14.1109H17.9264V13.3503ZM16.7719 10V13.2281C16.7719 13.7714 16.55 14.2649 16.1901 14.6225L16.1878 14.6248C15.8301 14.9825 15.3344 15.2066 14.7956 15.2066H10.7051V29.0221C10.7051 29.3571 10.8432 29.6604 11.0627 29.88C11.2846 30.0996 11.5879 30.2377 11.923 30.2377H24.7017C25.0367 30.2377 25.3401 30.0996 25.5596 29.88H25.5619C25.7815 29.6604 25.9196 29.3571 25.9196 29.0221V11.2179C25.9196 10.8829 25.7815 10.5795 25.5619 10.3599L25.5642 10.3577C25.3378 10.1358 25.0345 10 24.6994 10H16.7719ZM16.0112 13.2281V10.446L11.3502 14.4437H14.7956C15.1284 14.4437 15.434 14.3056 15.6536 14.086L15.6558 14.0838C15.8754 13.8664 16.0112 13.5631 16.0112 13.2281ZM24.6994 30.9983H17.6026L25.3853 33.9253C25.6977 34.0408 26.0305 34.0204 26.3157 33.8913C26.5987 33.7623 26.8341 33.5246 26.9518 33.2122L33.2178 16.5467C33.3355 16.2343 33.3129 15.8993 33.1839 15.6163C33.0548 15.3333 32.8194 15.0979 32.5047 14.9779L26.6779 12.7866V29.0198C26.6779 29.5631 26.4561 30.0566 26.0961 30.4165C25.7407 30.7765 25.245 30.9983 24.6994 30.9983Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33083_160978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5897,
    height: 24,
    fill: "white",
    transform: "translate(10.7051 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhanHeReport);
export default __webpack_public_path__ + "static/media/PhanHeReport.03f2b192.svg";
export { ForwardRef as ReactComponent };